import { META_FALLBACK_IMAGE } from './../constants'

export default ({ url, name, description }) => {
  // TODO: In event a url is not available don't return incomplete structured data
  if (!url) {
    return null
  }
  return {
    url,
    type: 'ShoppingCenter',
    title: name,
    description,
    image: META_FALLBACK_IMAGE,
  }
}
